import { footerColumns } from "@/mocks/home";

export default function SiteFooter() {
  return (
    <footer className="w-full bg-primary-950 text-background-100">
      <div className="max-w-[1360px] mx-auto px-4 md:px-8 pt-14 md:pt-16 pb-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-8 pb-10 border-b border-primary-800">
          <div className="lg:col-span-5">
            <div className="flex items-end gap-3">
              <span className="flex items-center justify-center w-10 h-10 rounded-md bg-accent-500 text-accent-950">
                <i className="ri-fire-fill text-xl" />
              </span>
              <span className="font-heading text-3xl md:text-4xl font-black text-background-50 leading-none">
                热点黑料
              </span>
            </div>
            <p className="mt-5 max-w-sm text-sm leading-relaxed text-primary-200">
              深挖热点事件背后的完整时间线，从起因到发酵全程还原，收录原文与背景资料，帮你理清黑料来龙去脉，看清事件全貌。
            </p>
            <div className="mt-6 flex items-center gap-3">
              {["ri-wechat-line", "ri-weibo-line", "ri-rss-line", "ri-mail-line"].map((icon) => (
                <button
                  key={icon}
                  type="button"
                  aria-label="社交入口"
                  className="flex items-center justify-center w-9 h-9 rounded-full border border-primary-700 text-primary-200 hover:border-accent-500 hover:text-accent-400 transition-colors cursor-pointer"
                >
                  <i className={icon} />
                </button>
              ))}
            </div>
          </div>

          {footerColumns.map((col) => (
            <div key={col.title} className="lg:col-span-2">
              <h4 className="font-heading text-sm font-bold tracking-wide text-background-50">
                <a href="#timeline" className="hover:text-accent-400 transition-colors">
                  {col.title}
                </a>
              </h4>
              <ul className="mt-4 space-y-2.5">
                {col.links.map((link) => (
                  <li key={link}>
                    <a
                      href="#timeline"
                      className="text-[13px] font-label text-primary-200 hover:text-accent-400 transition-colors whitespace-nowrap"
                    >
                      {link}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div className="lg:col-span-1">
            <a
              href="#flash"
              className="inline-flex items-center justify-center w-11 h-11 rounded-full bg-accent-500 text-accent-950 hover:bg-accent-400 transition-colors"
              aria-label="回到快讯流"
            >
              <i className="ri-arrow-up-line text-lg" />
            </a>
          </div>
        </div>

        <div className="pt-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-[11px] font-label text-primary-300">
          <span>© 2026 热点黑料 · 内容均为公开信息整理，仅作阅读参考</span>
          <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2">
            <a href="#archive" className="hover:text-accent-400 transition-colors whitespace-nowrap">
              资料来源规则
            </a>
            <a href="#background" className="hover:text-accent-400 transition-colors whitespace-nowrap">
              内容更正流程
            </a>
            <span className="flex items-center gap-1.5">
              <span className="w-1.5 h-1.5 rounded-full bg-secondary-400 animate-pulse-dot" />
              站点运行正常
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}